import React from 'react'
import Modal from 'react-modal'
import axios from 'axios'
import { useAuthState } from 'context'
import { Formik, Form } from 'formik'
import { useTranslation } from 'react-i18next';
import { userLang } from 'components/utils'
import {ReactComponent as ClearIcon} from '../../assets/images/svg/clear-icon.svg';
import {TextField} from '../inputs/TextField';

Modal.setAppElement('#root')

export const PassResetModal = ({ isOpen, setIsOpen }) => {
  const { token } = useAuthState()
  const { t } = useTranslation();

  const validate = (values) => {
    const errors = {}
    if (!values.email) {
      errors.email = t('required')
    }
    if (
      values.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = t('invalidMail')
    }
    return errors
  }

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(47, 128, 237, 0.5)',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 9,
      overflowY: 'auto',
    },
    content: {
      position: 'relative',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      height: 'fit-content',
      margin: '10px auto',
      maxWidth: '1120px',
      width: '95%',
      outlineWidth: 0,
      top: '20%'
    },
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false)
      }}
      overlayClassName={'modal_overlay no_aligin'}
      className={'modal modal-login'}
      style={customStyles}
      shouldCloseOnOverlayClick={true}
    >

        <div className="modal__phone">
            <div className="modal__head">
                <h2 className="modal__title">{t('restoreTitle')}</h2>
                <button className="modal__close" onClick={() => setIsOpen(false)}>
                    <ClearIcon />
                </button>
            </div>
          <div className="modal__wrap">
              <div className="modal__subtitle">
                  {t('restoreText')}
              </div>
            <Formik
              initialValues={{
            email: ''
              }}
              validate={(values) => {
                return validate(values)
              }}
              onSubmit={(values, { setFieldError }) => {
                axios.defaults.headers.common[
                  'Authorization'
                ] = `Bearer ${token}`
                axios
                  .post(
                    `${process.env.REACT_APP_BACKEND}/forgot-password`,
                   {email: values.email, locale: userLang().split('-')[0]}
                  )
                  .then((data) => {
                    console.log('asdasd')
                  })
                  .catch((e) => {
                    const { errors } = e.response.data
                    Object.keys(errors).forEach((key) => {
                      setFieldError(key, errors[key])
                    })
                  })

              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
              }) => (
                <Form
                  className="authorization__form authorization__form_reg js-registration-form"
                  onSubmit={handleSubmit}
                >
                    <div className="authorization__input-block" style={{margin: 0}}>
                        <TextField
                            name="email"
                            error={touched.email && errors.email}
                            value={values.email}
                            placeholder={t('email')}
                            handleChange={handleChange}
                        />
                    </div>
                    <div className="authorization__input-group buttons">
                        <button
                            className="btn btn_clean authorization__btn-submit button"
                            type="button"
                            style={{
                                fontSize: 16,
                                color: '#2F80ED',
                                textAlign: 'left',
                                textTransform: 'none',
                                fontWeight: 400
                            }}
                            onClick={() => {
                                setIsOpen(false)
                            }}
                        >
                            <span>{t('cancel')}</span>
                        </button>
                        <button
                            className="btn btn-red authorization__btn-submit button"
                            type="submit"
                        >
                        <span>
                          {t('send')}
                        </span>
                        </button>
                    </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
    </Modal>
  )
}
